var map = {
	"./arts.png": "b28a",
	"./beauty.png": "6184",
	"./education.png": "f158",
	"./food.png": "b8ba",
	"./health.png": "9d25",
	"./other.png": "855e",
	"./pets.png": "d513",
	"./shopping.png": "20a5",
	"./sports.png": "ce35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7800";